<template>
  <div class="ml_auction_manage">
    <div class="auction_header">
      <div class="auction_search">
        <div @click="showStoreList()" class="ml_auction_store">
          <img class="ml_auction_store_icon" src="../../assets/54.png" alt="">
          <div class="ml_auction_store_name">
            <span>{{ storeName }}</span>
            <img class="ml_auction_store_icon" src="../../assets/65.png" style="filter: none;margin-left:3px;width: 10px;object-fit: contain;" alt="">
          </div>

        </div>
        <span @click="goSearch()" class="ml_auction_search iconfont">&#xe655;</span>
      </div>
      <div class="auction_tab">
        <div class="auction_tab_item" v-for="(item,index) in tabList" :key="index" @click="changTab(item.status)" :class="{'auction_tab_item_active':status==item.status}">
          <span class="auction_tab_item_text">{{item.label}}</span>
        </div>
      </div>
    </div>

    <div class="ml_auction">
      <div class="ml_gird">
        <div class="ml_grid_3">
          <div class="ml_grid_item" v-for="(item, index) in cardList" :key="index"
            @click="goToAuctionList(item)">
            <div class="ml_grid_item_value">
              <text class="ml_price_value_font">
                {{ item.count }}
              </text>
            </div>
            <div class="ml_grid_item_text">
              <div class="ml_text_overflow">
                {{ item.gridName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 门店 -->
    <van-popup v-model:show="isVisitStore" @click-overlay="isVisitStore=false" :close-on-click-overlay="true" position="top">
      <div class="ml_single_top">
        <div class="ml_single_top_list">
          <div class="ml_single_top_item" :class="{ 'ml_single_top_item_active': storeId == item.value }"
            v-for="(item, index) in storeList" :key="index" @click.stop="onClickItem(item)">
              {{ item.label }}
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getStoreList,getListType } from '@/utils/auction'
export default {
  data() {
    return {
      cardList: [],
      storeList: [],
      storeName:'',
      storeId:"",
      isVisitStore:false,
      status:null,
      tabList:[
        {
          status:null,
          label:"总览"
        },
        {
          status:1,
          label:"本月"
        },
        {
          status:2,
          label:"本季"
        },
        {
          status:3,
          label:"本年"
        },
      ]
    };
  },
  async mounted() {
    this.sid = this.$route.query.sid
    await this.getStore()
    this.getListType()
  },
  methods: {
    onClickItem(item){
      this.storeId = item.value
      this.storeName = item.label
      this.isVisitStore = false
      this.getListType()
    },
    showStoreList(){
      this.isVisitStore = true
    },
    changTab(e){
      this.status = e
      this.getListType()
    },
    getStore(){
      getStoreList({}).then(res => {
        this.storeList = res.data
        this.storeName = res.data[0].label
        this.storeId = res.data[0].value
      })
    },
    getListType() {
      const that = this;
      getListType({rangeType:that.status,storeId:that.storeId}).then(res => {
        that.cardList = res.data;
      });
    },
    goSearch() {
      const that = this
      this.$router.push({
        path: "/auctionsearch",
        query:{
          sid:that.sid
        }
      })
    },
    goToAuctionList(e) {
      const that = this
      this.$router.push({
        path: "/auctionlist",
        query:{
          sid:that.sid,
          gridType:e.gridType,
          status:that.status,
          storeId:that.storeId,
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ml_auction_manage{
  min-height: 100vh;
  background-color: #F5F7F9;
  .auction_header{
    background: #ffffff;
    .auction_search{
      width: 100%;
      height: 44px;
      box-sizing: border-box;
      border-bottom: 0.5px solid #E9E9E9;
      padding: 12px 15px;
      margin: 0 auto;
      margin-bottom: 15px;
      line-height: 20px;
      display: flex;
      align-items: center;
      .ml_auction_store {
        width: calc(100% - 26px);
        display: flex;
        align-items: center;
        .ml_auction_store_icon {
          display: inline-block;
          vertical-align: middle;
          margin-right: 5px;
          height: 16px;
          width: 16px;
          filter: invert(0.8);
        }

        .ml_auction_store_name {
          font-size: 16px;
          vertical-align: middle;
          width: 80%;
          display: inline-block;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      .ml_auction_search {
        color: #000000;
        font-size: 20px;
        margin-left: 10px;
      }
    }
    .auction_tab{
      padding: 0 10px;
      display: flex;
      .auction_tab_item{
        width: 25%;
        line-height: 22px;
        padding-bottom: 10px;
        text-align: center;
        font-size: 14px;
        color: #000000;
        position: relative;
        .auction_tab_item_text{
          
        }
      }
      .auction_tab_item_active{
        font-size: 16px;
        color: #327FFF;
        font-weight: 600;
        &::after{
          content: '';
          width: 28px;
          height: 3px;
          background: #327fff;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
    }
  }
  
  .ml_auction {
    width: calc(100% - 50px);
    padding: 0 15px 20px;
    background: #FFFFFF;
    margin: 10px auto;
    border-radius: 8px;

    .ml_gird{
      padding-top: 5px;
    }
    .ml_grid_3 {
      display: grid;
      grid-template-columns: 33.33% 33.33% 33.33%;

      .ml_grid_item {
        text-align: center;

        .ml_grid_item_value {
          font-weight: bold;
          font-size: 18px;
          color: #332D29;
          line-height: 25px;
          padding-top: 15px;
        }

        .ml_price_value_font {
          font-family: '黑体';
        }

        .ml_grid_item_text {
          color: #979797;
          font-size: 14px;
          padding-top: 5px;
          line-height: 20px;
        }
      }
    }
  }
  .ml_single_top {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100vw;

    .ml_single_top_list {
      background-color: #FFFFFF;
      border-radius: 0 0 16px 16px;
      padding: 0 20px;
      max-height: 80vh;
      overflow-y: auto;

      .ml_single_top_item {
        padding: 15px 0;
        border-bottom: 1px solid rgba($color: #E9E9E9, $alpha: 0.3);
        color: #292D33;

        &:last-child {
          border-bottom: 0;
        }
      }

      .ml_single_top_item_active {
        color: #327FFF;
        background: url('../../assets/60.png') no-repeat center right;
        background-size: 25px 25px;
      }
    }
  }
}
</style>
